import { FunctionComponent } from "react";
import { useMediaQuery } from "react-responsive";
import {
  Link, To
} from "react-router-dom";

type HomeArticleCardType = {
  image?: string;
  date?: string;
  header?: string;
  readTime?: Number;
  url: To;
  imageMobile?: string
};

const RecentArticleCard: FunctionComponent<HomeArticleCardType> = ({
  image,
  date = new Date().toDateString(),
  header,
  readTime,
  url,
  imageMobile
}) => {
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 768px)' })

  return (
    <div className="flex flex-col items-center text-gray-700 font-inter w-full">
      <img
        className="w-8/12 max-h-[200px]"
        alt="Nylig artikel"
        title="Nylig artikel"
        sizes="(max-width: 480px) w-8/12, w-8/12"
        src={isTabletOrMobile ? imageMobile : image}
        loading="lazy"
      />
      <div className="text-4xs leading-[35px] font-semibold w-7/12 max-md:w-8/12 max-md:mr-0 mr-[9%] p-2">
        <div>
          {date}
        </div>
        <h3 className="text-base max-md: leading-[35px] font-semibold w-12/12 m-0">
          <Link className="max-w-sm no-underline text-gray-700 border border-gray-200 rounded-lg hover:bg-gray-100  dark:border-gray-700 dark:hover:bg-gray-300" to={url}>{header}</Link>
        </h3>
        <div>
          {readTime + " MIN. LÆSNING"}
        </div>
      </div>
    </div>
  );
};

export default RecentArticleCard;
